module.exports = __webpack_public_path__ + "img/ArrowIcon.4d00ed05.svg";